import map from 'lodash/map';

import { PartialAudienceFragment, AudiencesQuery, useAudiencesQuery } from '@occc/graphql';

const transformDataToAudiencesArray = (data: AudiencesQuery): PartialAudienceFragment[] => {
  const { edges } = data.audiences;
  return map(edges, 'node');
};

export const useGetAudiencesByIds = (audienceIds: string[], chainIdEquals?: string) => {
  const response = useAudiencesQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      first: 10,
      filter: {
        uuidContains: audienceIds,
        ...(chainIdEquals ? { chainIdEquals } : {}),
      },
    },
  });

  return {
    ...response,
    data: response.data ? transformDataToAudiencesArray(response.data) : response.data,
  };
};
